import { Row, Table } from "@tanstack/react-table";
import React, { useCallback, useState } from "react";

export function useTableRowsSelection<T>() {
  const [selectedRows, setSelectedRows] = useState<T[]>([]);

  const selectChildRows = (row: Row<T>, isSelected: boolean) => {
    row.subRows.forEach((subRow) => {
      subRow.toggleSelected(isSelected);
      if (isSelected) {
        setSelectedRows((prev) => [...prev, subRow.original]);
      } else {
        setSelectedRows((prev) =>
          prev.filter((item) => item !== subRow.original)
        );
      }
      if (subRow.subRows.length > 0) {
        selectChildRows(subRow, isSelected);
      }
    });
  };

  const onRowSelectionChange = useCallback(
    (row: Row<T>) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const shouldSelect = event.target.checked;
      row.toggleSelected(shouldSelect);
      if (shouldSelect) {
        setSelectedRows((prev) => [...prev, row.original]);
      } else {
        setSelectedRows((prev) => prev.filter((item) => item !== row.original));
      }
      selectChildRows(row, shouldSelect);
    },
    []
  );

  const onAllRowsSelectionChange = useCallback(
    (table: Table<T>) => (event: React.ChangeEvent<HTMLInputElement>) => {
      table.getToggleAllRowsSelectedHandler()(event);
      if (table.getIsAllRowsSelected()) {
        setSelectedRows([]);
      } else {
        setSelectedRows(
          table.getPreSelectedRowModel().rows.map((row) => row.original)
        );
      }
    },
    []
  );

  return {
    selectedRows,
    onRowSelectionChange,
    setSelectedRows,
    onAllRowsSelectionChange,
  };
}
